require('normalize.css/normalize.css');
require('animate.css/animate.min.css');
require('styles/App.css');

import React from 'react';
import LoadingComponent from './LoadingComponent';
import * as TotemActions from '../actions/TotemActions';
import TotemStore from '../stores/TotemStore';

class ConfigurationComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            brandId: 1,
            brands: TotemActions.getBrands()
        };
    }

    componentWillMount() {
        TotemStore.on('BRANDS_RECEIVED', this._onReceiveBrands.bind(this));
    }

    _onReceiveBrands() {
        this.setState({
            brands: TotemStore.getBrands()
        });
    }

    _handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value,
            isValid: (this.state.name !== '' && this.state.description !== '' && this.state.currency !== '' && this.state.price !== '' && this.state.linkUrl !== '' && this.state.categoryId !== '' && this.state.brandId !== '')
        });
    }

    _navigateToBrandBack() {
        this.props.history.push('/' + this.state.brandId);
    }

    render() {

        let { brands } = this.state;

        let brandOptions = [];

        if (brands) {
            brandOptions = brands.map((brand) => {
                return <option value={brand.id} key={brand.id}>{brand.name}</option>
            });
        }

        return (
            <div className="index container">
                <div className="center-align">
                    <div className="configuration-title left-align">
                        <h4>Configuración</h4>
                        <span>Puede volver a cambiar la configuración cuándo lo desee desde la aplicación.</span>
                    </div>
                    <div className="initial-configuration-block left-align">
                        <h5>Seleccionar sucursal</h5>
                        <span>Seleccione la sucursal en donde el backend se encontrará funcionando para recibir las notificaciones relacionadas con la misma.</span>
                        <div className="configuration-option">
                            <select className="browser-default" name="brandId" value={this.state.brandId} onChange={this._handleInputChange.bind(this)}>
                                {brandOptions}
                            </select>
                            <a className="waves-effect waves-light btn blue lighten">Nueva</a>
                        </div>
                    </div>
                    <div className="">
                        <a className="waves-effect waves-light btn blue darken-4" onClick={this._navigateToBrandBack.bind(this)}>Continuar</a>
                    </div>
                </div>
            </div>
        );
    }
}



ConfigurationComponent.defaultProps = {
};

export default ConfigurationComponent;



// WEBPACK FOOTER //
// ./src/components/Configuration.js